export const headerHeight = 0; // '60px'
// export const sidebarWidth = '240px';
export const sidebarWidth = '230px';
// export const sidebarCollapsedWidth = '60px';
export const sidebarCollapsedWidth = '74px';
export const sidebarTransitionDuration = '0.12s';
export const sidebarTransitionTimingFunction = 'ease-out';
